import { Component } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import {LoginService} from './login.service';
import * as CryptoJS from 'crypto-js';
import { sha256, sha224 } from 'js-sha256';
import { Router,RouterModule, NavigationEnd,NavigationStart} from '@angular/router';
import { Location } from '@angular/common';
import { ServerConstantsService } from './serverConstants.service';
import { HttpClient } from '@angular/common/http';
import 'rxjs/add/operator/filter';


@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent {
  title = 'SNAP Works';
  timeOut:Boolean = false;
  datetime:any;

  constructor(public loginService:LoginService, public toastService:ToastrService, public router:Router, public location:Location, private http: HttpClient){
    this.router.events
    .filter((event) => event instanceof NavigationStart)
    .subscribe((event:NavigationStart) => {
      if((sessionStorage.getItem('id') == null || sessionStorage.getItem('id') == undefined)){
        this.http.get("https://worldtimeapi.org/api/timezone/America/Chicago")
        .toPromise()
        .then(data => {
          this.datetime = new Date(data["datetime"]).getHours();
          if((this.datetime >= parseInt(ServerConstantsService.serverConstants.downtime)) || (this.datetime <= parseInt(ServerConstantsService.serverConstants.uptime))){
            this.router.navigate(['unavailable']);
          }
          else if(event.url !='/login' && event.url !='/help' && event.url.split('/')[1] !== 'redirect'){
            this.router.navigate(['login']);
          }
        });
      }
    });    
  }
  ngOnInit() {
    let key = sha256(ServerConstantsService.serverConstants.privateKey).toString();
    if(sessionStorage.getItem('id') != null && sessionStorage.getItem('id') != undefined){
      this.getUserInfo(parseInt(CryptoJS.AES.decrypt(sessionStorage.getItem('id'), key).toString(CryptoJS.enc.Utf8)));
    }
    sessionStorage.setItem('conversion_stat',CryptoJS.AES.encrypt('false',key).toString());
    this.authValidation();
    this.router.events
    .filter((event) => event instanceof NavigationEnd)
    .subscribe((event:NavigationEnd) => {
      if(event.urlAfterRedirects == '/login'){
        this.timeOut = false;
      }
      else{
        this.timeOut = true;
      }
    });
  }
  getUserInfo(id){
    this.loginService.getuser(id).subscribe((data)=>{
      if(data["id"]){
        this.loginService.personId = data["id"];
        let key = sha256(ServerConstantsService.serverConstants.privateKey).toString();
        sessionStorage.setItem('id',CryptoJS.AES.encrypt(data["id"].toString(),key).toString());
        this.loginService.firstName = data["firstName"];
        sessionStorage.setItem("firstName",CryptoJS.AES.encrypt(data["firstName"].toString(),key).toString());
        this.loginService.lastName = data["lastName"];
        sessionStorage.setItem("lastName",CryptoJS.AES.encrypt(data["firstName"].toString(),key).toString());
        CryptoJS.AES.decrypt(sessionStorage.getItem('conversion_stat'), key).toString(CryptoJS.enc.Utf8) === 'true' ?  
        this.getAriesCitizenInfo(data["emciId"]) :this.getcitizenInfo(data["ssn"]);
      }
      else{
        this.toastService.error("Unable to load User Information","My Dashboard");
      }
    },error=>{
      this.toastService.error("Unable to load User Information","My Dashboard");
    })
  }
  getcitizenInfo(ssn){
    let request = {
      "ssn":ssn
    }
    this.loginService.getClientinfo(request).subscribe((data:Array<Object>)=>{
      if(data[0]["CLIENTID"]){
        let key = sha256(ServerConstantsService.serverConstants.privateKey).toString();
        if(data[0]["BENEFIT"] == null){
          this.loginService.monthlyBenefit = 0;
        }
        else{
          this.loginService.monthlyBenefit = data[0]["BENEFIT"];
          sessionStorage.setItem('benefit',CryptoJS.AES.encrypt(data[0]["BENEFIT"].toString(),key).toString());
        }
        this.loginService.participationCode = data.find(obj => obj['HH_MEM_RELATIONSHIP'] == 'Self')['HH_MEM_WP'];
        sessionStorage.setItem('status',CryptoJS.AES.encrypt(this.loginService.participationCode.toString(),key).toString());
        //this.loginService.maxWage=Math.max.apply(Math, this.loginService.staticData.get("Maxwages").map(function(o) { return o.value; }));
      }
      else{
        this.toastService.error("Unable to load User Information","My Dashboard");
      }
    },error=>{
      this.toastService.error("Unable to load User Information","My Dashboard");
    })
  }

  getAriesCitizenInfo(value){
    let request = {
      "type":"clientInfo",
      "value":value
    }
    this.loginService.getClietinfoAries(request).subscribe((data:Array<Object>)=>{
      if(data[0]["indvId"]){
        let key = sha256(ServerConstantsService.serverConstants.privateKey).toString();
        if(data[0]["BENEFIT"] == undefined || data[0]["BENEFIT"] == null){
          this.loginService.monthlyBenefit = 0;
        }
        else{
          this.loginService.monthlyBenefit = data[0]["BENEFIT"];
          sessionStorage.setItem('benefit',CryptoJS.AES.encrypt(data[0]["BENEFIT"].toString(),key).toString());
        }
        this.loginService.participationCode = "Mandatory - SNAP";
        sessionStorage.setItem('status',CryptoJS.AES.encrypt(this.loginService.participationCode.toString(),key).toString());
        //this.loginService.maxWage=Math.max.apply(Math, this.loginService.staticData.get("Maxwages").map(function(o) { return o.value; }));
      }
      else{
        this.toastService.error("Unable to load User Information","My Dashboard");
      }
    },error=>{
      this.toastService.error("Unable to load User Information","My Dashboard");
    })
  }

  authValidation(){
    if((sessionStorage.getItem('id') == null || sessionStorage.getItem('id') == undefined)){
      this.http.get("https://worldtimeapi.org/api/timezone/America/Chicago")
      .toPromise()
      .then(data => {
        this.datetime = new Date(data["datetime"]).getHours();
        if((this.datetime >= parseInt(ServerConstantsService.serverConstants.downtime)) || (this.datetime <= parseInt(ServerConstantsService.serverConstants.uptime))){
          this.router.navigate(['unavailable']);
        }
        else if(this.location.path() !== '/help' && this.location.path().split('/')[1] !== 'redirect'){
          this.router.navigate(['login']);
        }
      });
    }
     /*if(sessionStorage.getItem('id') == undefined && this.location.path() != '/help' && this.location.path() != '/unavailable'){
      this.router.navigate(['login']);
    }*/
  }
  ngAfterViewInit():void{
    this.router.events.subscribe(event => {
        if (event instanceof NavigationEnd) { 
          (<any>window).ga('set', 'page', "Citizen Portal -" + event.urlAfterRedirects);
          if(event.url === '/'){
            (<any>window).ga('set', 'title', "Home Page");
          }
          else{
            (<any>window).ga('set', 'title', event.url.substr(1));
          }
          (<any>window).ga('send', 'pageview');
      }
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/app.component.ts